// This script manages the sticky CTA visibility on mobile when the user scrolls near the bottom of the page.
window.addEventListener('DOMContentLoaded', function () {
  const stickyCta = document.querySelector('.product__ctas--sticky');

  if (!stickyCta) return;

  const originalParent = stickyCta.parentElement;
  const originalNextSibling = stickyCta.nextSibling;

  function relocateStickyCta() {
    const body = document.querySelector('body');

    // 🔧 PRESERVE: Save the value of the quantity input before moving
    const quantityInput = stickyCta.querySelector('hh-quantity-input');
    const currentQuantity = quantityInput ? quantityInput._value : null;

    if (window.innerWidth < 750) {
      body.appendChild(stickyCta);
    } else {
      if (originalNextSibling) {
        originalParent.insertBefore(stickyCta, originalNextSibling);
      } else {
        originalParent.appendChild(stickyCta);
      }
    }

    // 🔧 RESTORE: Restore the value after moving
    if (quantityInput && currentQuantity !== null) {
      quantityInput._value = currentQuantity;
      // Also update the internal input HTML
      const inputElement = quantityInput.querySelector('.quantity-input__input');
      if (inputElement) inputElement.value = currentQuantity;
    }
  }

  function toggleStickyCta() {
    relocateStickyCta();
  }


  let subscriptionWidgetCounter = 0;

  const subscriptionInterval = setInterval(() => {
    const subscriptionWidgetLoaded = window.subscriptionWidgetLoaded || false;

    if (!!subscriptionWidgetLoaded) {

      clearInterval(subscriptionInterval);
      window.removeEventListener('scroll', toggleStickyCta);
      window.removeEventListener('resize', toggleStickyCta);

      window.addEventListener('scroll', toggleStickyCta);
      window.addEventListener('resize', toggleStickyCta);

      // Run when loading to see if it's already at the bottom
      toggleStickyCta();
    }
    else if (subscriptionWidgetCounter < 150) subscriptionWidgetCounter += 1
    else {

      clearInterval(subscriptionInterval);
      window.removeEventListener('scroll', toggleStickyCta);
      window.removeEventListener('resize', toggleStickyCta);

      window.addEventListener('scroll', toggleStickyCta);
      window.addEventListener('resize', toggleStickyCta);

      // Run when loading to see if it's already at the bottom
      toggleStickyCta();
    }

  },100);

});
